import { SecurityGuard } from "@duosoftbg/nacid-components";
import ServiceConfigWrapperPage from "../views/pages/ServiceConfigWrapperPage";
import { seRecognitionServiceConfig } from "../config/servicesConfig";
import React from "react";
import ServiceInfoPage from "../views/pages/ServiceInfoPage";
import SERecognitionNewPage from "../views/pages/secondaryEducation/SERecognitionNewPage";

export const seRecognitionRoutes = [
  {
    path: "/se-recognition",
    element: (
      <SecurityGuard doCheck={false}>
        <ServiceConfigWrapperPage serviceConfig={seRecognitionServiceConfig} wrappedPage={<ServiceInfoPage />} />
      </SecurityGuard>
    ),
  },
  {
    path: "/se-recognition/new",
    element: (
      <SecurityGuard loginOnUnauthorized={true}>
        <ServiceConfigWrapperPage serviceConfig={seRecognitionServiceConfig} wrappedPage={<SERecognitionNewPage />} />
      </SecurityGuard>
    ),
  },
];
